import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/PetaniRT.css"; // Pastikan file CSS umum sudah terhubung
import Swal from "sweetalert2";
import axios from "axios";

const RencanaTanam = () => {
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });
  const navigate = useNavigate();
  const location = useLocation();
  const [rencanaTanamList, setRencanaTanamList] = useState([]);
  const [tanggal, setTanggal] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    try {
      const [tanamResponse, userResponse] = await Promise.all([
        axios.get("https://c-greenproject.org:7500/view_rencana_tanam", { withCredentials: true }),
        axios.get("https://c-greenproject.org:7500/get_user_role", {
          withCredentials: true,
        }),
      ]);

      setRencanaTanamList(tanamResponse.data.tanams || []);
      const userData = userResponse.data;

      if (userData && !userData.error) {
        setUserInfo({
          role: userData.role,
          name: userData.name,
          full_name: userData.full_name,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
      Swal.fire("Gagal", "Gagal logout. Silakan coba lagi.", "error");
    }
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Hapus Rencana Tanam?",
      text: "Data yang dihapus tidak dapat dikembalikan. (Data tervalidasi tidak bisa dihapus)",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Ya, Hapus!",
      cancelButtonText: "Batal",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.delete(
            "https://c-greenproject.org:7500/delete_rencana_tanam",
            {
              data: { rencana_tanam_id: id },
              headers: { "Content-Type": "application/json" },
              withCredentials: true,
            }
          );

          if (response.status === 200) {
            setRencanaTanamList((prevData) =>
              prevData.filter((item) => item.id !== id)
            );
            Swal.fire("Terhapus!", response.data.message, "success");
          } else {
            Swal.fire("Gagal!", response.data.error, "error");
          }
        } catch (error) {
          console.error("Error deleting data:", error);
          Swal.fire(
            "Gagal",
            error.response?.data?.error || "Rencana tanam yang telah divalidasi tidak dapat dihapus/diedit.",
            "error"
          );
        }
      }
    });
  };

  const handleDetail = (id) => {
    navigate(`/petanirt/detail/${id}`);
  };

  // Injeksi CSS untuk SweetAlert Form agar lebih modern
  const injectSwalFormStyle = () => {
    if (document.getElementById("swal-grid-style")) return;

    const style = document.createElement("style");
    style.id = "swal-grid-style";
    style.innerHTML = `
      .swal-form {
        padding: 10px 0;
      }
      .swal-form-row {
        display: flex;
        flex-direction: column;
        text-align: left;
        margin-bottom: 15px;
      }
      .swal-form-row label {
        font-size: 13px;
        font-weight: 600;
        color: #4b5563;
        margin-bottom: 6px;
      }
      .swal-form-row .swal2-input {
        width: 100%;
        height: 42px;
        font-size: 14px;
        margin: 0 !important;
        border-radius: 8px;
        border: 1px solid #d1d5db;
        box-sizing: border-box;
      }
      .swal-form-row .swal2-input:focus {
        border-color: #198754;
        box-shadow: 0 0 0 0.2rem rgba(25, 135, 84, 0.25);
      }
      .swal2-actions {
        margin-top: 20px !important;
      }
      .swal2-confirm, .swal2-cancel {
        border-radius: 50rem !important;
        padding: 10px 24px !important;
        font-weight: 600 !important;
      }
    `;
    document.head.appendChild(style);
  };

  const handleEdit = (id) => {
    const tanam = rencanaTanamList.find((t) => t.id === id);

    Swal.fire({
      title: "Edit Rencana Tanam",
      html: `
        <div class="swal-form">
          <div class="swal-form-row">
            <label>Nama Petani</label>
            <input class="swal2-input bg-light" value="${tanam.nama}" disabled>
          </div>
          <div class="swal-form-row">
            <label>ID Lahan</label>
            <input id="lahan_id" class="swal2-input" value="${tanam.lahan_id}">
          </div>
          <div class="swal-form-row">
            <label>Jenis Sawit</label>
            <input id="jenis_sawit" class="swal2-input" value="${tanam.jenis_sawit}">
          </div>
          <div class="swal-form-row">
            <label>Jumlah Tanaman</label>
            <input id="jumlah_tanaman" type="number" class="swal2-input" value="${tanam.jumlah_tanaman}">
          </div>
          <div class="swal-form-row">
            <label>Tanggal Tanam</label>
            <input id="tanggal_penanaman" type="date" class="swal2-input" value="${tanam.tanggal_penanaman.split("T")[0]}">
          </div>
          <div class="swal-form-row">
            <label>Jenis Pupuk</label>
            <input id="jenis_pupuk" class="swal2-input" value="${tanam.jenis_pupuk}">
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonColor: "#0d6efd",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Simpan Perubahan",
      cancelButtonText: "Batal",
      focusConfirm: false,
      didOpen: injectSwalFormStyle,
      preConfirm: () => {
        return {
          rencana_tanam_id: id,
          lahan_id: document.getElementById("lahan_id").value,
          jenis_sawit: document.getElementById("jenis_sawit").value,
          jumlah_tanaman: Number(document.getElementById("jumlah_tanaman").value),
          tanggal_penanaman: document.getElementById("tanggal_penanaman").value,
          jenis_pupuk: document.getElementById("jenis_pupuk").value,
        };
      },
    }).then((res) => {
      if (res.isConfirmed) {
        axios
          .put("https://c-greenproject.org:7500/edit_rencana_tanam", res.value, { withCredentials: true })
          .then((r) => {
            Swal.fire("Sukses", r.data.message, "success");
            fetchData();
          })
          .catch((e) => {
            Swal.fire(
              "Error",
              e.response?.data?.error || "Rencana tanam yang telah divalidasi tidak dapat diedit.",
              "error"
            );
          });
      }
    });
  };

  const handleTambahkan = () => {
    Swal.fire({
      title: "Tambah Rencana Tanam",
      html: `
        <div class="swal-form">
          <div class="swal-form-row">
            <label>Nama Petani</label>
            <input class="swal2-input bg-light" value="${userInfo.full_name}" disabled>
          </div>
          <div class="swal-form-row">
            <label>ID Lahan</label>
            <input id="lahan_id" class="swal2-input" placeholder="Contoh: 5">
          </div>
          <div class="swal-form-row">
            <label>Jenis Sawit</label>
            <input id="jenis_sawit" class="swal2-input" placeholder="Contoh: Tenera">
          </div>
          <div class="swal-form-row">
            <label>Jumlah Tanaman (Pohon)</label>
            <input id="jumlah_tanaman" type="number" class="swal2-input" placeholder="Contoh: 1200">
          </div>
          <div class="swal-form-row">
            <label>Tanggal Tanam</label>
            <input id="tanggal_penanaman" type="date" class="swal2-input">
          </div>
          <div class="swal-form-row">
            <label>Jenis Pupuk</label>
            <input id="jenis_pupuk" class="swal2-input" placeholder="Contoh: NPK">
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonColor: "#198754",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Simpan Data",
      cancelButtonText: "Batal",
      focusConfirm: false,
      didOpen: injectSwalFormStyle,
      preConfirm: () => {
        const data = {
          nama: userInfo.full_name,
          lahan_id: document.getElementById("lahan_id").value,
          jenis_sawit: document.getElementById("jenis_sawit").value,
          jumlah_tanaman: Number(document.getElementById("jumlah_tanaman").value),
          tanggal_penanaman: document.getElementById("tanggal_penanaman").value,
          jenis_pupuk: document.getElementById("jenis_pupuk").value,
        };

        if (
          !data.lahan_id ||
          !data.jenis_sawit ||
          !data.jumlah_tanaman ||
          !data.tanggal_penanaman ||
          !data.jenis_pupuk
        ) {
          Swal.showValidationMessage("Semua field wajib diisi");
          return false;
        }
        return data;
      },
    }).then((res) => {
      if (res.isConfirmed) {
        axios
          .post("https://c-greenproject.org:7500/add_rencana_tanam", res.value, { withCredentials: true })
          .then((r) => {
            Swal.fire("Berhasil", r.data.message, "success");
            fetchData();
          })
          .catch((e) => {
            Swal.fire("Error", e.response?.data?.error || "Terjadi kesalahan", "error");
          });
      }
    });
  };

  // Helper Badge Status
  const getStatusBadge = (status) => {
    const s = String(status || "").toLowerCase().trim();
    if (s === "approved" || s === "disetujui") {
      return <span className="badge bg-success-subtle text-success px-3 py-2 rounded-pill border border-success-subtle fw-semibold">Disetujui</span>;
    }
    if (s === "rejected" || s === "ditolak") {
      return <span className="badge bg-danger-subtle text-danger px-3 py-2 rounded-pill border border-danger-subtle fw-semibold">Ditolak</span>;
    }
    return <span className="badge bg-warning-subtle text-warning-emphasis px-3 py-2 rounded-pill border border-warning-subtle fw-semibold">Menunggu Validasi</span>;
  };

  return (
    <div className="d-flex flex-column bg-light min-vh-100">
      {/* Header */}
      <div className="header bg-white shadow-sm border-bottom">
        <img src="/static/logo_potrait.png" alt="Logo Telsa Super Apps" />
        <div className="top-right">
          <span className="fw-medium text-secondary" style={{ cursor: "pointer" }} onClick={() => navigate("/profile")}>
            {userInfo.full_name} |
          </span>
          <button className="btn btn-outline-danger btn-sm rounded-pill px-3 ms-2" onClick={handleLogout}>
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <div className="sidebar p-3 bg-white shadow-sm" id="sidebar">
          <p id="sidebar-title" className="text-muted small mb-1">Portal Sistem Traceability</p>
          <h6 id="sidebar-subtitle" className="fw-bold text-success mb-3">Telsa Super Apps</h6>
          <p id="sidebar-date" className="bg-light p-2 rounded-3 text-muted small fw-medium d-flex align-items-center gap-2">
            <img src="/static/schedule_11145854.png" alt="Date" style={{ width: "16px" }} />
            {tanggal}
          </p>
          <div className="list-group list-group-flush mt-3" id="sidebar-menu">
            <div
              onClick={() => navigate("/petani")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petani" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/petani" ? "brightness(0) invert(1)" : "none" }} /> Beranda
            </div>
            <div
              onClick={() => navigate("/petanirt")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanirt" || location.pathname.includes("/petanirt") ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/Tanam.png" alt="Planting" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/petanirt" || location.pathname.includes("/petanirt") ? "brightness(0) invert(1)" : "none" }} /> Rencana Tanam
            </div>
            <div
              onClick={() => navigate("/petanirp")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanirp" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/panen.png" alt="Harvest" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/petanirp" ? "brightness(0) invert(1)" : "none" }} /> Rencana Panen
            </div>
            <div
              onClick={() => navigate("/petanifp")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanifp" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/FinalPanen.png" alt="Final Panen" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/petanifp" ? "brightness(0) invert(1)" : "none" }} /> Final Panen
            </div>
            <div
              onClick={() => navigate("/petanip")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanip" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/sell_8087698.png" alt="Sales" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/petanip" ? "brightness(0) invert(1)" : "none" }} /> Penjualan
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content flex-grow-1 p-4 w-100">
          
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="fw-bold text-dark mb-0">Rencana Tanam</h2>
            <button
              className="btn btn-success rounded-pill px-4 shadow-sm fw-medium"
              onClick={handleTambahkan}
            >
              <i className="fa fa-plus me-2"></i>Tambah Rencana Tanam
            </button>
          </div>

          <div className="divider mb-4"></div>

          {/* Table Container Card */}
          <div className="content-box p-4 border-0 shadow-sm rounded-4 bg-white">
            <h4 className="fw-bold text-success mb-3">Daftar Rencana Tanam</h4>

            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="text-muted mt-2">Memuat data rencana tanam...</p>
              </div>
            ) : rencanaTanamList && rencanaTanamList.length > 0 ? (
              <div className="table-responsive" style={{ overflowX: "auto" }}>
                <table className="table table-hover align-middle" style={{ minWidth: "900px" }}>
                  <thead className="table-light text-nowrap">
                    <tr>
                      <th className="text-center py-3" style={{ width: "60px", borderTopLeftRadius: "10px" }}>No</th>
                      <th className="text-center py-3" style={{ width: "80px" }}>ID</th>
                      <th className="py-3">Nama Petani</th>
                      <th className="text-center py-3">Tanggal Tanam</th>
                      <th className="text-center py-3">Status</th>
                      <th className="text-center py-3" style={{ width: "240px", borderTopRightRadius: "10px" }}>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rencanaTanamList.map((item, index) => (
                      <tr key={`rt-${item.id || index}`}>
                        <td className="text-center fw-bold text-muted">{index + 1}</td>
                        <td className="text-center font-monospace fw-bold text-secondary">
                          #{item.id}
                        </td>
                        <td className="fw-semibold text-dark text-capitalize text-nowrap">
                          {item.nama || "-"}
                        </td>
                        <td className="text-center text-muted text-nowrap">
                          {item.tanggal_penanaman || "-"}
                        </td>
                        <td className="text-center text-nowrap">
                          {getStatusBadge(item.status_validasi)}
                        </td>
                        <td className="text-center">
                          <div className="d-flex justify-content-center gap-2">
                            <button
                              className="btn btn-outline-info btn-sm rounded-pill px-3 fw-medium text-nowrap shadow-sm"
                              onClick={() => handleDetail(item.id)}
                            >
                              Detail
                            </button>
                            <button
                              className="btn btn-outline-warning btn-sm rounded-pill px-3 fw-medium text-nowrap shadow-sm"
                              onClick={() => handleEdit(item.id)}
                            >
                              Edit
                            </button>
                            <button
                              className="btn btn-outline-danger btn-sm rounded-pill px-3 fw-medium text-nowrap shadow-sm"
                              onClick={() => handleDelete(item.id)}
                            >
                              Hapus
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-5 text-muted bg-light rounded-3 mt-2">
                <i className="fa fa-leaf mb-3 opacity-50" style={{ fontSize: "3rem" }}></i>
                <h5 className="fw-semibold">Belum Ada Rencana Tanam</h5>
                <p className="mb-0">Silakan tambahkan data rencana tanam baru Anda.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RencanaTanam;